import { render, staticRenderFns } from "./add-compensation-modal.vue?vue&type=template&id=018d74aa"
import script from "./add-compensation-modal.ts?vue&type=script&lang=ts&external"
export * from "./add-compensation-modal.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('018d74aa')) {
      api.createRecord('018d74aa', component.options)
    } else {
      api.reload('018d74aa', component.options)
    }
    module.hot.accept("./add-compensation-modal.vue?vue&type=template&id=018d74aa", function () {
      api.rerender('018d74aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/in-year-budget-requests/create-in-year-budget-request/create-iybr-form/add-compensation-modal/add-compensation-modal.vue"
export default component.exports